import EfficientMoveCycle from './EfficientMoveCycle';
import Timer from '../core/Timer';
function Drag(element, handle, minX, maxX, minY, maxY, callback, callbackStarted) {
    var minXPercent;
    var maxXPercent;
    var self = this;
    if (minY == undefined) {
        minY = 0;
    }
    if (minX== undefined) {
        minX = 0;
    }
    if (maxY== undefined) {
        maxY = 2000;
    }
    if (maxX== undefined) {
        maxX = 100;
    }
    var state = 0;
    var start;
    var timer;
    this.setPosition = function (array) {
        self.drag(array[0], array[1]);
    };
    this.getPosition = function () {
        var array = [];
        array[0] = element.offsetLeft;
        array[1] = element.offsetTop;
        return array;
    };
    const efficientMovingCycle = new EfficientMoveCycle({ 
		element:handle, stopPropagation:false, preventDefault:true, onStart:onStart, onMove:onMove, onEnd:onEnd , friendlyXY:true});
	
	let startedButNotMovedYet= false;
	this.updateMinMax = function(){
		maxXPercent = maxX - ((100 * element.offsetWidth) / document.documentElement.clientWidth);
        minXPercent = minX;
        if (maxXPercent < 0) {
            maxXPercent = 0;
        }
        else {
            if (maxXPercent > 100) {
                maxXPercent = 100;
            }
        }
	};
    function onStart(e)
    {
		startedButNotMovedYet = true;
		const {x, y}= e;
        if (element.style.display === "none")
        {
            return;
        }
        start = [element.offsetLeft - x, element.offsetTop - y];
        self.updateMinMax();
        timer = new Timer({callback:function () { if (callback != undefined) { callback(); } }, delay:1000, nTicks:1});
        state = 1;
    }
    function onMove(e)
    {
		if(startedButNotMovedYet){
			startedButNotMovedYet = false;
			if(!Drag.cancel)
				if(callbackStarted)callbackStarted(e);
		}
		const {x, y}= e;
        if(!Drag.cancel)
        if (state == 1) {
            self.drag((start[0] + x), (start[1] + y));
            timer.reset(true);
        }
    }
    this.drag=function(x, y)
    {
		var left = 100 * x / document.documentElement.clientWidth;
		if (left < minXPercent) {
			left = minXPercent;
		}
		else {
			if (left > maxXPercent) {
				left = maxXPercent;
			}
		}
		element.style.left = String(left) + '%';
		if (y < minY) {
			y = minY;
		}
		else {
			if (y+element.offsetHeight > maxY) {
				y = maxY - element.offsetHeight;
			}
		}
		element.style.top = String(y) + 'px';
    };
    function onEnd(e) {         
        Drag.cancel=false;
        state=0;
    };
}
export default Drag;